import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../../models/user';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { select, Store } from '@ngrx/store';
import { addUserCompanyAct } from '../../../store/companies-user/companies-user-actions';
import { distinctUntilChanged, map } from 'rxjs';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-add-user-dialog',
  standalone: false,
  templateUrl: './add-user-dialog.component.html',
  styleUrl: './add-user-dialog.component.css',
  providers: [provideNativeDateAdapter()]
})
export class AddUserDialogComponent {

  user: User= new User();
  userForm!: NgForm;
  loading: boolean = true;
  violations: any;
  idCompany: string;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { idCompany: string },
    private dialogRef: MatDialogRef<AddUserDialogComponent>,
    private companyUserStore: Store<{ companiesUserRdc: any }>,
    private cd: ChangeDetectorRef
  ) {
    this.idCompany = data.idCompany;
    this.violations = [];
    this.loading = false;

    this.companyUserStore.pipe(
        select('companiesUserRdc'),
        map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
          //user: state.user,
          violations: state.violations,
          loading: state.loading
        })),
        // evita repeticiones
        distinctUntilChanged((prev, curr) =>
          JSON.stringify(prev) === JSON.stringify(curr)
        )
      ).subscribe(({ violations, loading }) => {
      this.violations = violations;
      //this.offerSignatureRequested = JSON.parse(JSON.stringify(signatureRequested)); // o mejor: _.cloneDeep(offer)
      
      this.loading = loading;
      this.cd.markForCheck(); // fuerza la actualización de la vista
      //console.log("cargando " + this.loading);

      if(this.userForm){
        for (const controlName in this.userForm.controls) {
          if (this.userForm.controls.hasOwnProperty(controlName)) {
            const control = this.userForm.controls[controlName];
            if(this.violations[controlName]){
              control.setErrors({'incorrect': true});
            }
          }
        }
      }
    });
    
  }

  onSubmit(userForm: NgForm): void {
    this.loading = true;
    this.userForm = userForm;
    const userCopy = JSON.parse(JSON.stringify(this.user));

    userCopy.person.email = userCopy.email;

    if (userCopy.id > 0) {
      //this.userStore.dispatch(updateUserAct({ userUpdated: userCopy }));
    } else {
      this.companyUserStore.dispatch(addUserCompanyAct({id: this.idCompany, userNew: userCopy}));
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
